import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateLastCollectComponent } from './update-last-collect.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { UiModule } from '../ui/ui.module';

@NgModule({
  declarations: [
    UpdateLastCollectComponent,
  ],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    UiModule,
    MatCardModule,
    MatGridListModule,
    MatIconModule,
    MatSelectModule,
  ],
})

export class UpdateLastCollectModule { }
